import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import TopBarProgress from "react-topbar-progress-indicator";
import { createSearchParams } from "react-router-dom";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";

import {
  getFilterCategories
} from "../../../actions/filters";

import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import { Pagination } from "@mui/material";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";

const CategoriesMain = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Local State
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SearchFilterr, setSearchFilterr] = useState({
    title: "",
  });

  // Api calls for get Order
  const getAttributes = useCallback(
    async (
      pageNo,
      title,
    ) => {
      setloading(true);
      const res = await dispatch(
        getFilterCategories(
          pageNo,
          title
        )
      );
      if (res) {
        console.log({ res })
        setData(res?.combinedCategories);
        setpagination(res?.pagination);
      }
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getAttributes(pagination.currentPage, SearchFilterr.title);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage,
  SearchFilterr.title]);


  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({
        page: value,
      })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };



  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div
            className=" d-flex  justify-content-end align-center flex-wrap"
            style={{ gap: "20px" }}
          >
            <SearchFilter
              type="text"
              placeholder={"Search Name"}
              value={SearchFilterr?.title}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFilterr({
                  ...SearchFilterr,
                  title: e.target.value,
                });
              }}

            />


          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Filter Categories"
              subTitle="Filter List"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Category Image</th>
                      <th>Categories</th>
                      <th>Top 5 Order</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item?.image ? <img src={item?.image} height={20} width={20} alt={item.name} /> : <></>}</td>
                            <td>{item.name}</td>
                            <td>{item?.filter.map((filter) => (<button className="btn btn-primary mr-1 mb-1 btn-sm text-small">{filter.title}</button>))}</td>

                            <td>
                              <CustomeTableBtn
                                color="black"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/create-filter/?id=${item._id}`
                                  )
                                }
                              >
                                Organize Filters
                              </CustomeTableBtn>



                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default CategoriesMain;
